import { EuiButton, EuiButtonIcon, EuiCallOut, EuiFieldText, EuiFlexGroup, EuiFlexItem, EuiFormRow, EuiIcon, EuiLink, EuiOverlayMask, EuiPopover, EuiSelect, EuiSuperSelect, EuiText } from '@elastic/eui';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { UsuariosFacturablesDisponiblesInfo } from './usuariosFacturablesPopover';
import { PERFIL_ADMIN } from '../../../../../shared/constanst/constants';
import { AnioActual, AniosFacturacionExpatriados, MesActual, MesesFacturacionExpatriados } from '../../../../../shared/utils/constants';
import { SelectorValidadoresAS400Container } from '../../../components/Selectores/ValidadoresAS400/container';

const Anios = AniosFacturacionExpatriados().map((a)=>{ return {value: a, text:a.toString()} })

export const FilterComponent = (props) =>{

    const {tipo,dataFilter,onClickVisualizarFactura,onGenerarFactura,onRefreshEstadoUsers,user,dataHistorico,translate,onFacturaAs400} = props;

    const optionTipos = [{value: 0, text:translate('retencion-hipotetica-acotado')},{value: 1, text:translate('irpf').toUpperCase()}]

    const [anio, setAnio] = useState(AnioActual.toString());
    const [mes, setMes] = useState(MesActual.toString());
    const [tipoEspecial, setTipo] = useState(0);
    const [nFactura, setNFactura] = useState('');
    const [validador, setValidador] = useState(null);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [avisoMesAnteriorView, setAvisoMesAnterior] = useState(false)

    //const isSuperAdmin = useMemo(()=>{ return  user && (user.esSuperAdmin)},[user])
    const meses = useMemo(()=> MesesFacturacionExpatriados(parseInt(anio),false),[anio, MesesFacturacionExpatriados]);

    // useEffect(()=>{
    //     onRefreshEstadoUsers && onRefreshEstadoUsers({mes:mes,tipoEspecial:tipoEspecial})
    // },[mes,tipoEspecial])

    useEffect(()=>{
            const _selectedMonth = (meses && meses.filter((f)=> f.disabled===false).slice(-1)[0]) //{value:'1'}
            _selectedMonth && setMes(_selectedMonth.value)
    },[meses])

    const ShowbtnVisualizar = useMemo(()=>user && (user.perfil === PERFIL_ADMIN || user.administraExpatriados),[user])
    const ShowbtnFacturar = useMemo(()=>user && (user.perfil === PERFIL_ADMIN || user.administraExpatriados),[user])

    const filterParams = useMemo(()=> {
        const {idSociedad,referencia,grupoFactura} = dataFilter;

        return {id:idSociedad.toString(),anio:parseInt(anio),mes:parseInt(mes),
            irpf:parseInt(tipoEspecial),tipoAgrupacion:tipo,referenciaFactura:referencia,grupoFactura:grupoFactura}}
    ,[dataFilter, anio, mes, tipoEspecial, tipo])

    const onClickFacturar = () =>{
        const dataFacturacion = {...filterParams,...{idFactura:nFactura, validador:validador}}
        delete dataFacturacion.tipoAgrupacion;

        onGenerarFactura(dataFacturacion)
        setIsPopoverOpen(false)
    }

    const onClickVisualizar = () =>{
        const dataFacturacion = {...filterParams}

        delete dataFacturacion.tipoAgrupacion;
        const soloVisualizar = true;
        onClickVisualizarFactura(dataFacturacion,soloVisualizar)
    }

    // const onClickAs400 =() =>{
    //     const {tipo} = dataFilter;
    //     onFacturaAs400(nFactura,tipo)
    //     setIsPopoverOpen(false)
    // }

    const onPopoverClick = () => setIsPopoverOpen((isPopoverOpen) => !isPopoverOpen);
    const closePopover = () => setIsPopoverOpen(false);

    const hayValidador = useMemo(()=> (validador!==null),[validador])

    const inValidNFactura = useMemo(()=> nFactura.length<8 ,[nFactura])

    const esMesAnterior = useMemo(()=>
        (parseInt(anio)<AnioActual || (parseInt(anio)===AnioActual && (parseInt(mes)===MesActual-1)))
    ,[anio,mes,AnioActual,MesActual])

    const buttonFacturar = useCallback(()=>
        ShowbtnFacturar ? <EuiButton size='s' onClick={onPopoverClick} fill style={{borderRadius:'0px'}}>
        {`${translate('facturar')}`}
        </EuiButton>
        :null
    ,[onPopoverClick,ShowbtnFacturar,translate,hayValidador]);

    const buttonVisualizar = useCallback(()=>
        ShowbtnVisualizar ? 
        <EuiButton className='btn-download-popup expatriados' fullWidth fill size='s' onClick={()=>onClickVisualizar()}>{`${translate('visualizar')}`}</EuiButton>
        : null
    ,[onClickVisualizar,ShowbtnVisualizar])

    const buttonInfoUsers = useCallback(()=>
        <UsuariosFacturablesDisponiblesInfo filter={filterParams} lenDataHistorico={dataHistorico}/>
    ,[filterParams,dataHistorico])

    // const getBtnAS400 = useMemo(()=>{
    //     return (
    //     user && user.dni.toLowerCase() === 'dni-certifica' 
    //     ?   <EuiFlexItem><EuiButton fullWidth size='s' onClick={()=>onClickAs400()}>Subir AS400</EuiButton></EuiFlexItem>
    //     : null
    // )},[user,onClickAs400])

    const getBtnConfiguracionValidadores = ()=>(
            <EuiFlexGroup justifyContent='center' alignItems='center'>
                <EuiFlexItem><span>Validador AS400</span></EuiFlexItem>
                <EuiFlexItem grow={false}>
                    <EuiButtonIcon iconSize='m' iconType='gear' color='primary' href='/MiConfiguracion/MisDatos'/></EuiFlexItem>
            </EuiFlexGroup>
    )

    const getInfoValidadorAS400 = ()=>{
        // const _msg = hayValidador ? <p>Tienes un validador asignado. Puedes configurarlo <EuiLink href={'/MiConfiguracion/MisDatos'}>{<strong>aquí</strong>}</EuiLink>.</p> : 
        // <p>No tienes asignado un validador, configúralo <EuiLink href={'/MiConfiguracion/MisDatos'}>{<strong>aquí</strong>}</EuiLink> para poder realizar facturaciones.</p>;

        const _msg = <p>Sin Validadores asignados, configúralo. <span><EuiIcon size='s' type='gear' color='primary'/></span></p>
        return !hayValidador && (<EuiFlexItem><EuiText className={`msgValidador-factura ${hayValidador?'success':'wrong'}`}>{_msg}</EuiText></EuiFlexItem>)
    }

    const popoverFacturar = (
        <EuiPopover
          ownFocus={false}
          button={buttonFacturar()}
          isOpen={isPopoverOpen}
          closePopover={closePopover}
          initialFocus="[id=popover-facturar-expatriados]">
            <EuiFlexGroup direction='column'>
                <EuiFlexItem>
                <EuiCallOut title={`${translate('realizar-facturacion')}`} color="warning" iconType="alert" style={{maxWidth:'300px'}}>
                    <p>
                    {`${translate('msg-realizar-factura')}.`}
                    </p>
                </EuiCallOut>
                </EuiFlexItem>
                <EuiFlexItem>
                    <EuiFlexGroup direction='column'>
                        <EuiFlexItem>
                            <EuiFieldText placeholder={`${translate('nFactura')} (8 ${translate('digitos')})`} maxLength={8} minLength={8}
                            value={nFactura} onChange={(e)=> setNFactura(e.target.value)} 
                            />
                        </EuiFlexItem>
                        <EuiFlexItem>
                            <EuiFormRow isInvalid={!hayValidador} label={getBtnConfiguracionValidadores()} fullWidth>
                            <SelectorValidadoresAS400Container compressed valueOfSelected={validador} onChange={value=> setValidador(value)}/>
                            </EuiFormRow>
                        </EuiFlexItem>
                        {getInfoValidadorAS400()}
                        <EuiFlexItem>
                            <EuiButton disabled={inValidNFactura || !hayValidador} 
                            className={`btn-download-popup expatriados ${inValidNFactura || !hayValidador?'disabled':''}`} 
                            fullWidth fill size='s' onClick={()=>onClickFacturar()}>{`${translate('generar-factura')}`}</EuiButton>
                        </EuiFlexItem>
                        {/* {getBtnAS400} */}
                    </EuiFlexGroup>
                </EuiFlexItem>
            </EuiFlexGroup>
          </EuiPopover>
    )

    const accionesFacturacion = (
        <>
            <EuiFlexItem grow={false}>
                {buttonVisualizar()}
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
                {popoverFacturar}
            </EuiFlexItem>
        </>
    )
    
    const msgInfoMesAnterior = (
        <EuiFlexItem>
            <EuiCallOut size="s" title={<p style={{fontSize:'smaller'}}>
                {`${translate('msg-aviso-facturacion-mesanterior')} `}
                <EuiLink href="#" onClick={()=>{setAvisoMesAnterior(true)}}>{`Aceptar`}</EuiLink>.
                </p>} 
            color="warning">
            </EuiCallOut>
        </EuiFlexItem>
    )

    const isVisible = useMemo(()=>(dataFilter.referencia!==null),[dataFilter])
    const hidden = useMemo(()=>(dataFilter.referencia===undefined),[dataFilter])

    return isVisible ? (
        <EuiFlexGroup justifyContent='spaceBetween' style={{visibility:`${hidden?'hidden':'visible'}`}}>
           <EuiFlexItem grow={5}>
            <EuiFlexGroup>
                <EuiFlexItem grow={false}>
                    <EuiSelect
                    onChange={(e) => {setAnio(e.target.value)}}
                    options={Anios}
                    value={anio}
                    />
                </EuiFlexItem>
                <EuiFlexItem grow={6}>
                    <EuiSuperSelect
                    fullWidth
                    onChange={setMes}
                    options={meses}
                    valueOfSelected={mes}
                    />
                </EuiFlexItem>
                <EuiFlexItem grow={false}>
                    <EuiSelect
                    onChange={(e) => {setTipo(e.target.value)}}
                    options={optionTipos}
                    value={tipoEspecial}
                    />
                </EuiFlexItem>
                {/* <EuiFlexItem grow={false}>
                    <EuiSelect
                    disabled
                    onChange={(e) => {setIdioma(e.target.value)}}
                    options={Idiomas}
                    value={idioma}
                    />
                </EuiFlexItem> */}
                <EuiFlexItem grow={false}>
                    {buttonInfoUsers()}
                </EuiFlexItem>
            </EuiFlexGroup>
           </EuiFlexItem>
        
            <EuiFlexItem grow={4}>
            
                <EuiFlexGroup justifyContent='flexEnd'>
                    {(esMesAnterior && avisoMesAnteriorView === false) ? msgInfoMesAnterior : accionesFacturacion}
                </EuiFlexGroup>

            </EuiFlexItem>
        </EuiFlexGroup>
    ) : <EuiText color='danger' textAlign='center'>{`Para poder facturar, es necesario seleccionar una referencia de facturación.`}</EuiText>
}